export let catchUpHeaderLabel = "HOTx3b";
export let headlinesHeaderLabel = "YbLAW";
export let needsReplyViewLabel = "u1f2Sd";
export default {catchUpHeaderLabel,headlinesHeaderLabel,needsReplyViewLabel};